import { useState } from "react";
import { format } from "date-fns";

const toInputDate = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return "";
  return format(date, "yyyy-MM-dd");
};

const fromInputDate = (value) => {
  if (!value) return null;
  const [y, m, d] = value.split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
};

export default function AdminFilterBar({
  keyword,
  onChangeKeyword,
  keywordPlaceholder,
  searchField,
  onChangeSearchField,
  searchFieldOptions = [],
  extraFilters = [],
  startDate = null,
  endDate = null,
  onChangeDateRange,
  onSubmit,
  onResetAll,
  isLoading = false,
  resultCount = 0,
  resultUnit = "개",
  showDateRange = true,
}) {
  const [isDateModalOpen, setIsDateModalOpen] = useState(false);
  const [draftStart, setDraftStart] = useState(startDate);
  const [draftEnd, setDraftEnd] = useState(endDate);

  const openDateModal = () => {
    setDraftStart(startDate);
    setDraftEnd(endDate);
    setIsDateModalOpen(true);
  };

  const applyDateRange = () => {
    onChangeDateRange?.(draftStart, draftEnd);
    setIsDateModalOpen(false);
  };

  const clearDateRange = () => {
    onChangeDateRange?.(null, null);
    setDraftStart(null);
    setDraftEnd(null);
  };

  return (
    <div className="card kpiFilterCard">
      <form className="kpiFilterRow" onSubmit={onSubmit}>
        {searchFieldOptions.length > 0 ? (
          <select
            className="filterSelect"
            value={searchField}
            onChange={(e) => onChangeSearchField?.(e.target.value)}
          >
            {searchFieldOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        ) : null}

        <input
          className="searchInput"
          value={keyword}
          onChange={(e) => onChangeKeyword?.(e.target.value)}
          placeholder={keywordPlaceholder}
        />

        {extraFilters.map((filter) => (
          <select
            key={filter.key}
            className="filterSelect"
            value={filter.value}
            onChange={(e) => filter.onChange?.(e.target.value)}
          >
            {filter.options.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        ))}

        {showDateRange ? (
          <>
            <div className="datePickerInlineWrap">
              <button
                className="ghostBtn dateToggleBtn"
                type="button"
                onClick={openDateModal}
              >
                생성일 기간 선택
              </button>

              {isDateModalOpen ? (
                <div className="dateInlinePanel">
                  <div className="dateInputRow">
                    <label>
                      시작일
                      <input
                        type="date"
                        value={toInputDate(draftStart)}
                        onChange={(e) => setDraftStart(fromInputDate(e.target.value))}
                      />
                    </label>
                    <label>
                      종료일
                      <input
                        type="date"
                        value={toInputDate(draftEnd)}
                        onChange={(e) => setDraftEnd(fromInputDate(e.target.value))}
                      />
                    </label>
                  </div>

                  <div className="dateInlineFooter">
                    <button
                      className="ghostBtn"
                      type="button"
                      onClick={() => setIsDateModalOpen(false)}
                    >
                      취소
                    </button>
                    <button
                      className="primaryBtn"
                      type="button"
                      onClick={applyDateRange}
                    >
                      적용
                    </button>
                  </div>
                </div>
              ) : null}
            </div>

            <button className="ghostBtn" type="button" onClick={clearDateRange}>
              날짜 초기화
            </button>
          </>
        ) : null}

        <button className="ghostBtn clearBtn" type="button" onClick={onResetAll}>
          전체 초기화
        </button>
        <button className="searchSubmitBtn" type="submit" disabled={isLoading}>
          {isLoading ? "조회중..." : "검색"}
        </button>

        {showDateRange ? (
          <p className="dateHint">
            선택 기간: {startDate ? format(startDate, "yyyy-MM-dd") : "시작일 없음"} ~{" "}
            {endDate ? format(endDate, "yyyy-MM-dd") : "종료일 없음"}
          </p>
        ) : null}
      </form>

      <p className="filterStats">
        조회 결과 {resultCount}
        {resultUnit}
        {isLoading ? " (불러오는 중)" : ""}
      </p>
    </div>
  );
}
